var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["category-new-search.j2"] = require( "category-new-search.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/empty/category-empty-filter.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/urls.j2", false, "category/templates/empty/category-empty-filter.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
if(t_1.hasOwnProperty("categoryUrl")) {
var t_5 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_5);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_6 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_6);
output += "\n\n<div class=\"o-row o-column o-extra-small--12\">\n\n    <div class=\"c-category-filter-outer\">\n\n        <div class=\"c-category-filter\">\n\n            <h2 class=\"c-category-filter__h2\">\n                ";
output += runtime.suppressValue((lineno = 11, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_filter-no-results-heading"])), env.opts.autoescape);
output += "\n            </h2>\n\n            <div class=\"c-search-no-results\" data-qa-no-results=\"\">\n\n                <h3 class=\"c-category-filter__h3\">\n                    ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "search")) {
output += "\n                        ";
var t_7;
t_7 = (lineno = 18, colno = 59, runtime.callWrap(t_4, "searchUrl", context, ["q=" + "" + env.getFilter("replace").call(context, env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"searchTerm")),"%20","+")]));
frame.set("categoryFilterHref", t_7, true);
if(frame.topLevel) {
context.setVariable("categoryFilterHref", t_7);
}
if(frame.topLevel) {
context.addExport("categoryFilterHref", t_7);
}
output += "\n                    ";
;
}
else {
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "brands")) {
output += "\n                        ";
var t_8;
t_8 = (lineno = 20, colno = 59, runtime.callWrap(t_6, "brandsUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")]));
frame.set("categoryFilterHref", t_8, true);
if(frame.topLevel) {
context.setVariable("categoryFilterHref", t_8);
}
if(frame.topLevel) {
context.addExport("categoryFilterHref", t_8);
}
output += "\n                    ";
;
}
else {
output += "\n                        ";
var t_9;
t_9 = (lineno = 22, colno = 61, runtime.callWrap(t_5, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")]));
frame.set("categoryFilterHref", t_9, true);
if(frame.topLevel) {
context.setVariable("categoryFilterHref", t_9);
}
if(frame.topLevel) {
context.addExport("categoryFilterHref", t_9);
}
output += "\n                    ";
;
}
;
}
output += "\n\n                    <a class=\"c-category-filter__a\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "categoryFilterHref"), env.opts.autoescape);
output += "\">\n                        ";
output += runtime.suppressValue((lineno = 26, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_reset-facets"])), env.opts.autoescape);
output += "\n                    </a>\n\n                    <label class=\"c-category-filter__label\" for=\"new-search-input\">";
output += runtime.suppressValue((lineno = 29, colno = 85, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_filter-no-results-or"])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 29, colno = 122, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_filter-no-results-search-label"])), env.opts.autoescape);
output += "</label>\n\n                </h3>\n\n            </div>\n\n            <div class=\"o-row o-column o-extra-small--12 o-medium--10 o-medium--offset-1 o-large--8 o-large--offset-2\">\n\n                <div class=\"c-new-search\">\n                    ";
env.getTemplate("category-new-search.j2", false, "category/templates/empty/category-empty-filter.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/empty/category-empty-filter.j2"] , dependencies)